import { RtkqSpin } from '@app/base';
import {
  CatalogCareHomeLookup,
  CatalogCareHomeType,
  useLazyGetCatalogCareHomeLookupListQuery,
} from '@app/medical-record/api';
import { createEntireLoadOptionSource, emptyOptionSource, OptionSource } from '@webinex/antik';
import { useMemo } from 'react';

export interface UseCatalogCareHomeOptionSourceArgs {
  type?: CatalogCareHomeType;
  skip?: boolean;
}

export interface CatalogCareHomeOption {
  label: string;
  value: string;
  type: CatalogCareHomeType;
  address?: CatalogCareHomeLookup['address'];
}

export function mapCatalogCareHomeOption(value: CatalogCareHomeLookup): CatalogCareHomeOption {
  return {
    label: value.name,
    value: value.id,
    type: value.type,
    address: value.address,
  };
}

export function useCatalogCareHomeOptionSource(
  args: UseCatalogCareHomeOptionSourceArgs | void,
): OptionSource<CatalogCareHomeOption> {
  const { type, skip } = args ?? {};
  const [fetch, { currentData }] = useLazyGetCatalogCareHomeLookupListQuery();

  return useMemo(
    () =>
      skip
        ? emptyOptionSource<CatalogCareHomeOption>()
        : createEntireLoadOptionSource(() =>
            fetch({ archived: false, [RtkqSpin]: false }, true)
              .unwrap()
              .then((res) => res.filter((x) => !type || x.type === type).map(mapCatalogCareHomeOption)),
          ),
    [type, fetch, currentData],
  );
}
